<script>
  import ImageProductCard from './ImageProductCard.svelte';
  import Rating from './Rating.svelte';

  /**
 *
 *
 */
  /*                */
  let { mainVariation } = $props();

  const { averageRatingRounded, brandName, formattedPrice, image, name, numberOfReviews } =
    mainVariation;
  const variation = { averageRatingRounded, numberOfReviews };
</script>

<div class="oc-py-0 oc-br-50">
  <oc-row-v2 hide-divider variant="image">
    <div class="reco_aos_product_bundle_item__link oc-pt-25">
      <div class="reco_aos_product_bundle_item__left_side">
        <ImageProductCard {image} description={name} isBundle={true} />
        <div class="reco_aos_product_bundle_item_container">
          <div class="oc-copy-75 reco_aos_product_bundle_item__name">
            {brandName}
            {name}
          </div>
          <Rating {variation} />
        </div>
      </div>

      <div class="reco_aos_product_bundle_item__right_side">
        {#if formattedPrice.originalPrice === undefined || formattedPrice.retailPrice === formattedPrice.originalPrice}
          <div class="oc-copy-100 oc-copy--bold">{formattedPrice.retailPrice}</div>
        {:else}
          <div class="color-red oc-copy-100 oc-copy--bold">
            {formattedPrice.retailPrice}
          </div>
          <div class="line-through oc-copy-75">{formattedPrice.originalPrice}</div>
        {/if}
      </div>
    </div>
  </oc-row-v2>
</div>

<style lang="scss">
  .reco_aos_product_bundle_item_container {
    display: flex;
    flex-direction: column;
  }

  .reco_aos_product_bundle_item__link {
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
  }

  .reco_aos_product_bundle_item__left_side {
    display: flex;
  }

  .reco_aos_product_bundle_item__right_side {
    display: flex;
    width: 80px;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;
    margin-left: 8px;
    text-wrap: nowrap;
  }

  .reco_aos_product_bundle_item__name {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow-wrap: anywhere;
  }

  .reco_aos_product_bundle_item__right_side .line-through {
    text-decoration: line-through;
  }

  .reco_aos_product_bundle_item__right_side .color-red {
    color: var(--oc-semantic-color-brand);
  }
</style>
